<template>
    <div id="basic-info" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('settings.Edit_reference_type') }}</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-12">
            <div class="input-group input-group-static null">
              <label>{{ $t('settings.Name') }}</label>
              <input v-model="state.name" type="text" class="form-control form-control-default" placeholder="Name">
              <span v-if="v$.name.$error" class="text-sm text-danger">
                      {{ v$.name.$errors[0].$message }}
              </span>
            </div>           
          </div>                    
        </div>        
        <div class="col-12 col-sm-12 mt-6">                                
          <input type="hidden" v-model="state.id" class="form-control">          
          <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
          <button v-on:click="updateReferenceType" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Update') }}</button>                                                    
        </div>        
      </div>
    </div>    
  </template>
  
  <script>
  import axios from 'axios'
  import useValidate from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { reactive, computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  
  export default {
    name: "ReferenceTypeDetail",
    setup() {
        const { t } = useI18n()

        const state = reactive ({            
            referencetype: [],
            id: '',
            name: ''
        })

        const rules = computed(() => {
            return {
              name: { required: helpers.withMessage(t('common.Required'), required) },                                
            }
        })  
        
        const v$ = useValidate(rules, state)

        return {
            state,
            v$,
        }
    },    
    components: {     
    },
    data() {
      return {        
        gets: [],        
      };
    },
    async mounted() {  
      this.id = this.$route.params.id;            
      await this.fetchReferenceTypeData(this.$route.params.id);         
    },
    methods: { 
     
      async fetchReferenceTypeData(referenceTypeId) {
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`ReferenceType/${referenceTypeId}`);
            this.gets = response.data;

            if (this.gets.success) {
                this.state.referencetype = this.gets.data;
                this.state.id = this.state.referencetype.id;
                this.state.name = this.state.referencetype.name;
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          this.$showError('errors.Contact_system_admin');
        } finally {        
          this.$store.commit('setShowLoading', false);
        }
      },

      async updateReferenceType() {   
        try {
            this.$store.commit('setShowLoading', true);

            this.v$.$validate();                
            console.log(this.v$.$error);

            if(!this.v$.$error) {
                const response = await axios.put('ReferenceType/update', {
                  "id": this.state.id,
                  "name": this.state.name
                });
                this.gets = response.data;

                if (this.gets.success) {
                  this.$showSuccess('errors.Success_reference_type_updated_successfully');                      
                  this.$router.push('/settings');
                } else {
                  this.$showError('errors.Contact_system_admin');
                }
            }                
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
        this.$store.commit('setShowLoading', false);
      },
    }
  };
</script>  
<style>
.choices {
  margin-bottom: 0px !important;
}
</style>